<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'VSearchDataProvider',
    computed: mapGetters('search', {
		items: 'items'
	}),
	props: {
		apiUrl: {
			type: String,
			default: ''
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: this.isLoading
		}
	},
	methods: {
		getItems(value) {
			this.loading = true;
			this.$store.dispatch('search/fetchItems', {
				apiUrl: this.apiUrl,
				q: value
			}).then(() => {
				this.loading = false;
			});
		},
	},
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
			getItems: this.getItems,
			items: this.items,
			loading: this.loading
		};

        return this.$scopedSlots.default(slotScope);
    }
}
</script>
